import { render, staticRenderFns } from "./SelectorLocaleFlag.vue?vue&type=template&id=2128bafc&scoped=true&"
import script from "./SelectorLocaleFlag.vue?vue&type=script&lang=js&"
export * from "./SelectorLocaleFlag.vue?vue&type=script&lang=js&"
import style0 from "./SelectorLocaleFlag.vue?vue&type=style&index=0&id=2128bafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128bafc",
  null
  
)

export default component.exports